import { useRef, useState, useEffect } from "react";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate, useParams } from "react-router-dom";
import TopBar from "./TopBar";

const UpdateCustomer = () => {
  const axiosPrivate = useAxiosPrivate();
  const userRef = useRef();
  const errRef = useRef();
  const { auth } = useAuth();
  const UPDATE_CUSTOMER_URL = "api/update-customer";
  const { customerId } = useParams();

  const [responseMessage, setResponseMessage] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [CustomerAddress1, setCustomerAddress1] = useState("");
  const [CustomerAddress2, setCustomerAddress2] = useState("");
  const [CustomerEmail, setCustomerEmail] = useState("");
  const [Pincode, setPincode] = useState("");
  const [City, setCity] = useState("");
  const [State, setState] = useState("");
  const [Phone, setPhone] = useState("");
  const [Mobile, setMobile] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [validName, setValidName] = useState(false);
  const [nameFocus, setNameFocus] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const GET_CUSTOMER_URL = "api/get-customer";
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosPrivate.get(GET_CUSTOMER_URL, {
          params: { customer_id: customerId },
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        });

        const data = response.data;
        setCustomerName(data.customer_name);
        setCustomerEmail(data.customer_email);
        setCustomerAddress1(data.customer_address1);
        setCustomerAddress2(data.customer_address2);
        setPincode(data.customer_pincode);
        setCity(data.customer_city);
        setState(data.customer_state);
        setPhone(data.customer_phone);
        setMobile(data.customer_mobile);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data");
        setLoading(false);
      }
    };

    fetchData();
  }, [axiosPrivate, customerId]);

  const postCreateCustomer = async () => {
    try {
      const data = {
        customer_id: customerId,
        customer_name: customerName,
        franchise_id: auth.franchise_id,
        customer_address1: CustomerAddress1,
        customer_address2: CustomerAddress2,
        customer_pincode: Pincode,
        customer_city: City,
        customer_state: State,
        customer_phone: Phone,
        customer_mobile: Mobile,
        customer_email: CustomerEmail,
      };

      await axiosPrivate.post(UPDATE_CUSTOMER_URL, data);
      navigate("/ListCustomers");
    } catch (error) {
      console.error("Error:", error?.response?.data?.message || error.message);

      const errorData = error.response?.data?.message;

      if (Array.isArray(errorData)) {
        const fieldErrors = {};
        errorData.forEach((err) => {
          if (err.path) {
            fieldErrors[err.path] = err.msg;
          }
        });

        const errorMsg = errorData[0]?.msg;
        setResponseMessage(errorMsg);
      } else {
        setResponseMessage(errorData || "An unexpected error occurred.");
      }
    }
  };

  if (loading) return <div>Loading customer data...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <section className="userregbody">
        <p
          ref={errRef}
          className={errMsg ? "errmsg" : "offscreen"}
          aria-live="assertive"
        >
          {errMsg}
        </p>

        <div className="wrapper3">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              postCreateCustomer();
            }}
          >
            <h3>Edit Customer</h3>

            {responseMessage && (
              <div className="response-message success">
                <p>{responseMessage}</p>
              </div>
            )}

            <Row>
              <Col>
                <div className="input-boxs">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    ref={userRef}
                    onChange={(e) => setCustomerName(e.target.value)}
                    value={customerName}
                    required
                    aria-invalid={validName ? "false" : "true"}
                    aria-describedby="namenote"
                    onFocus={() => setNameFocus(true)}
                    onBlur={() => setNameFocus(false)}
                  />
                  <p
                    id="namenote"
                    className={
                      nameFocus && !validName ? "instructions" : "offscreen"
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    Name is required!
                  </p>
                </div>
              </Col>
              <Col>
                <div className="input-boxs">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    onChange={(e) => setCustomerEmail(e.target.value)}
                    value={CustomerEmail}
                    required
                    aria-invalid={validEmail ? "false" : "true"}
                    aria-describedby="emailnote"
                    onFocus={() => setEmailFocus(true)}
                    onBlur={() => setEmailFocus(false)}
                  />
                  <p
                    id="emailnote"
                    className={
                      emailFocus && CustomerEmail && !validEmail
                        ? "instructions"
                        : "offscreen"
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    E-mail is required!
                  </p>
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="input-boxs">
                  <label htmlFor="CustomerAddress1">Address1</label>
                  <input
                    type="text"
                    id="CustomerAddress1"
                    onChange={(e) => setCustomerAddress1(e.target.value)}
                    value={CustomerAddress1}
                    required
                  />
                </div>
              </Col>
              <Col>
                <div className="input-boxs">
                  <label htmlFor="CustomerAddress2">Address2</label>
                  <input
                    type="text"
                    id="CustomerAddress2"
                    onChange={(e) => setCustomerAddress2(e.target.value)}
                    value={CustomerAddress2}
                    required
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="input-boxs">
                  <label htmlFor="Pincode">Pincode</label>
                  <input
                    type="text"
                    id="Pincode"
                    onChange={(e) => setPincode(e.target.value)}
                    value={Pincode}
                    required
                  />
                </div>
              </Col>
              <Col>
                <div className="input-boxs">
                  <label htmlFor="City">City</label>
                  <input
                    type="text"
                    id="City"
                    onChange={(e) => setCity(e.target.value)}
                    value={City}
                    required
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="input-boxs">
                  <label htmlFor="State">State</label>
                  <input
                    type="text"
                    id="State"
                    onChange={(e) => setState(e.target.value)}
                    value={State}
                    required
                  />
                </div>
              </Col>
              <Col>
                <div className="input-boxs">
                  <label htmlFor="Phone">Phone</label>
                  <input
                    type="text"
                    id="Phone"
                    onChange={(e) => setPhone(e.target.value)}
                    value={Phone}
                    required
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="input-boxs">
                  <label htmlFor="Mobile">Mobile</label>
                  <input
                    type="text"
                    id="Mobile"
                    onChange={(e) => setMobile(e.target.value)}
                    value={Mobile}
                    required
                  />
                </div>
              </Col>
            </Row>

            <center>
              <button type="submit" className="btn regbutton">
                Submit
              </button>
            </center>
          </form>
        </div>
      </section>
      <TopBar />
    </>
  );
};

export default UpdateCustomer;
